<template>
    <div class="o-avia-schedule-table">
        <div class="avia-schedule-table-label">{{ label }}</div>
        <div class="avia-schedule-table-container">
            <table>
                <thead>
                    <tr>
                        <th 
                            v-for="cell in headerCells"
                            :key="cell"                        
                        >
                            {{ cell }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="flight in data"
                        :key="flight.id"
                    >
                        <td>{{ flight.nearestTime }}</td>
                        <td>{{ flight.airportName }}</td>
                        <td>{{ flight.airlineName }}</td>
                        <td>{{ flight.flight_id }}</td>
                        <td>{{ flight.region }}</td>
                        <td>{{ flight.check_in }} {{ flight.gate }}</td>
                        <td>{{ flight.status }}</td>
                        <td>{{ flight.time }}</td>
                        <td>{{ flight.delayed }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OAviaScheduleTable',
    props: {
        headerCells: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
